<template>
  <div>
    <section>
      <h1>Patch list items</h1>

      <div class="script-columns">
        <div>
          <ul
            class="company-items"
            v-for="company in companies"
            :key="company.id"
          >
            <li :class="{converted: companiesConverted.includes(company.id)}">
              <strong
                >{{ company.name }}
                <span @click="getSites(company.id)"
                  >Covert {{ company.id }}</span
                ></strong
              >
            </li>
          </ul>
        </div>

        <div>
          <ul class="site-items" style="background: grey">
            <li
              v-for="site in sites"
              :key="site.id"
              :class="{converted: sitesConverted.includes(site.id)}"
            >
              {{ site.name }}
              <span @click="getPages(site.id)">Get Pages</span>
            </li>
          </ul>
        </div>

        <div>
          <ul class="site-items" style="background: grey">
            <li
              v-for="page in pages"
              :key="page.id"
              :class="{converted: pagesConverted.includes(page.id)}"
            >
              {{ page.name }}
              <span @click="getLists(page.id)">Get lists ({{ page.id }})</span>
            </li>
          </ul>
        </div>

        <div>
          <ul class="site-items" style="background: grey">
            <li
              v-for="list in lists"
              :key="list.id"
              :class="{converted: listsConverted.includes(list.id)}"
            >
              {{ list.name }}
              <span @click="getListItems(list, list.id)">Get items ({{ list.id }})</span>
            </li>
          </ul>
        </div>

        <div>
          <ul class="site-items">
            <li
              v-for="listItem in listItems"
              :key="listItem.id"
              :class="{converted: listItemsConverted.includes(listItem.id)}"
            >
              {{listItem.key}}
              <span @click="convertListItem(listItem)">Convert</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import page from '@/mixins/page'
import pagination from '@/mixins/pagination'

import {readCompaniesData} from '@/lib/companies'
import {readCompanySitesData} from '@/lib/sites'

import {readCompanySitePagesData} from '@/lib/pages'

import {readCompanySitePageListsData} from '@/lib/lists'

import {
  updateCompanySitePageListListItemData,
  readCompanySitePageListListItemsData
} from '@/lib/list_items'

import {readListTypesData} from '@/lib/list_types'

export default {
  name: 'ReplaceImageItems',

  mixins: [page, pagination],

  data() {
    return {
      converting: false,
      companiesConverted: [],
      success: false,
      steppingThrough: false,
      pages: [],
      companies: [],
      sitesConverted: [],
      pagesConverted: [],
      listsConverted: [],
      listItemsConverted: [],
      listItems: [],
      company: {},
      site: {},
      selectedSite: {},
      siteId: '',
      pageId: '',
      companyId: '',
      sites: [],
      page: {},
      list: {},
      hasImages: [
        'slideshow',
        'feature-blocks',
        'text-image',
        'image-cards',
        'image-grid',
        'basic-gallery',
        'mini-carousel',
        'team-members'
      ],
      lists: [],
      listTypes: [],
      errors: {},
      siteGalleries: [],
      galleryId: '',
      basicGalleryId: ''
    }
  },

  computed: {
    listHasImages() {
      return (list) => {
        let name = this.listTypes.find((type) => type.id === list.list_type_id)
          .name
        return this.hasImages.includes(name)
      }
    },

    featureBlocksId() {
      return this.listTypes.find((type) => type.name === 'feature-blocks').id
    },

    slideshowBlocksId() {
      return this.listTypes.find((type) => type.name === 'slideshow').id
    },

    textImageBlocksId() {
      return this.listTypes.find((type) => type.name === 'text-image').id
    },

    imageCardsBlocksId() {
      return this.listTypes.find((type) => type.name === 'image-cards').id
    },

    imageGridBlocksId() {
      return this.listTypes.find((type) => type.name === 'image-grid').id
    },

    basicGalleryBlocksId() {
      return this.listTypes.find((type) => type.name === 'basic-gallery').id
    },

    miniCarouselBlocksId() {
      return this.listTypes.find((type) => type.name === 'mini-carousel').id
    },

    teamMemberBlocksId() {
      return this.listTypes.find((type) => type.name === 'team-members').id
    }
  },

  methods: {
    getData() {
      readCompaniesData({page: 1, page_size: 250}).then(({data, page}) => {
        this.companies = data
        this.pageData = page
      })

      readListTypesData().then(({data}) => {
        this.listTypes = data
      })
    },

    getSites(companyId) {
      this.companyId = companyId
      this.companiesConverted.push(companyId)

      readCompanySitesData(companyId, {page: 1, page_size: 250}).then(
        ({data}) => {
          let sites = data

          if (sites.length) {
            this.sites = sites
          } else {
            this.sites = []
          }
        }
      )
    },

    convert(listItem, img) {
      updateCompanySitePageListListItemData(
        this.companyId,
        this.siteId,
        this.pageId,
        this.listId,
        listItem.id,
        img
      )
        .then(({data}) => {
        })
        .catch(() => {})
    },

    getPages(siteId) {
      this.siteId = siteId
      this.sitesConverted.push(siteId)

      readCompanySitePagesData(this.companyId, siteId, {page: 1, page_size: 250}).then(({data}) => {
        this.pages = data
      })
    },

    getLists(pageId) {
      this.pagesConverted.push(pageId)
      this.pageId = pageId

      readCompanySitePageListsData(this.companyId, this.siteId, pageId, {page: 1, page_size: 250}).then(
        ({data}) => {
          this.lists = data
        }
      )
    },

    getListItems(list, listId) {
      this.listsConverted.push(listId)
      this.list = list
      this.listId = list.id

      readCompanySitePageListListItemsData(
        this.companyId,
        this.siteId,
        this.pageId,
        listId,
        {page: 1, page_size: 250}
      ).then(({data}) => {
        this.listItems = data
      })
    },

    convertListItem(listItem) {
      this.listItemsConverted.push(listItem.id)

      this.listItemId = listItem.id
      let image

      if (this.list.list_type_id === this.featureBlocksId) {
        image = {image: JSON.parse(listItem.value).image} || false

        if (image) {
          this.convert(listItem, image)
        }
      }

      if (this.list.list_type_id === this.slideshowBlocksId) {
        image = {image: JSON.parse(listItem.value).image_url} || false

        if (image) {
          this.convert(listItem, image)
        }
      }

      if (this.list.list_type_id === this.textImageBlocksId) {
        image = {image: JSON.parse(listItem.value).image_url} || false

        if (image) {
          this.convert(listItem, image)
        }
      }

      if (this.list.list_type_id === this.imageCardsBlocksId) {
        image = {image: JSON.parse(listItem.value).image_url} || false

        if (image) {
          this.convert(listItem, image)
        }
      }

      if (this.list.list_type_id === this.imageGridBlocksId) {
        image = {image: JSON.parse(listItem.value).image} || false

        if (image) {
          this.convert(listItem, image)
        }
      }

      if (this.list.list_type_id === this.basicGalleryBlocksId) {
        image = {image: JSON.parse(listItem.value).url} || false

        if (image) {
          this.convert(listItem, image)
        }
      }

      if (this.list.list_type_id === this.miniCarouselBlocksId) {
        image = {image: JSON.parse(listItem.value).image_url} || false

        if (image) {
          this.convert(listItem, image)
        }
      }

      if (this.list.list_type_id === this.teamMemberBlocksId) {
        image = {image: JSON.parse(listItem.value).image} || false

        if (image) {
          this.convert(listItem, image)
        }
      }
    }
  },

  mounted() {
    this.getData()
  }
}
</script>

<style lang="sass" scoped>
li
  margin-bottom: 20px

.script-columns
  display: flex

  div
    flex-basis: 20%

.site-items
  position: sticky
  top: 0

.company-items
  .converted
    background: green

.site-items
  span
    background: red
    padding: 2px
    border-radius: 3px

  .converted
    background: green
</style>
